import React, { useState, useEffect } from 'react'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { I18n } from 'react-redux-i18n'

import { updateActionsErrors } from 'redux/smartchat/details/actions'
import { setAlternativesActionsErrors } from 'redux/smartchat/alternatives/actions'
import CourtesyMessagesViewUI from './CourtesyMessagesViewUI'

const CourtesyMessagesView = ({ renderType, label, placeholder, dataWay, currentValue, onChange, error }) => {
  const { modalActionRef } = useSelector(store => ({
    modalActionRef: dataWay?.type === 'alternatives'
      ? store.smartchatAlternatives.alternativesModalActionRef.find(modalActionRef => modalActionRef.alternativesId === dataWay.alternativesId) || {}
      : store.smartchatDetails.modalActionRef
  }), shallowEqual)
  const dispatch = useDispatch()
  const [value, setValue] = useState({})
  const [dataToExport, setDataToExport] = useState(currentValue || {})
  const [previewIntegrity, setPreviewIntegrity] = useState({})
  const courtesyMessagesOptions = [
    { value: 'HELLO', label: I18n.t('smartchat_actions_HELLO') },
    { value: 'BYE', label: I18n.t('smartchat_actions_BYE') },
    { value: 'THANKS', label: I18n.t('smartchat_actions_THANKS') }
  ]
  const helloPetitionsOptions = [
    { value: 1, label: I18n.t('smartchat_hello_first') },
    { value: 2, label: I18n.t('smartchat_hello_second') }
  ]
  const byePetitionsOptions = [
    { value: 1, label: I18n.t('smartchat_bye_first') },
    { value: 2, label: I18n.t('smartchat_bye_second') }
  ]
  const thanksPetitionsOptions = [
    { value: 1, label: I18n.t('smartchat_thanks_first') },
    { value: 2, label: I18n.t('smartchat_thanks_second') }
  ]

  // Current data
  useEffect(() => {
    let isSubscribed = true

    if (isSubscribed) {
      if (!currentValue || !Object.keys(currentValue).length) return

      if (renderType === 'action') {
        if (modalActionRef.mode !== 'update') return
        onChange(currentValue)
      }

      let option = null
      const error = { COMMAND: {} }
      const updatedValue = { ...value }
      const updatedPreviewIntegrity = { ...previewIntegrity }

      // Message
      option = courtesyMessagesOptions.find(courtesyMessage => courtesyMessage.value === currentValue.intentId)
      if (option) {
        if (updatedPreviewIntegrity.message) updatedPreviewIntegrity.message = null
        updatedValue.message = option
      } else {
        // Error
        if (renderType === 'action') {
          if (updatedValue.message !== null) error.COMMAND.message = I18n.t('smartchat_tooltip_warning_notFound')
        } else {
          updatedPreviewIntegrity.message = I18n.t('smartchat_tooltip_warning_notFound')
        }
      }

      // Petition
      let options = []
      if (updatedValue.message?.value === 'HELLO') options = helloPetitionsOptions
      if (updatedValue.message?.value === 'BYE') options = byePetitionsOptions
      if (updatedValue.message?.value === 'THANKS') options = thanksPetitionsOptions
      option = options.find(option => option.value === currentValue.repetitionNumber)
      if (option) {
        if (updatedPreviewIntegrity.petition) updatedPreviewIntegrity.petition = null
        updatedValue.petition = option
      } else {
        // Error
        if (renderType === 'action') {
          if (updatedValue.petition !== null) error.COMMAND.petition = I18n.t('smartchat_tooltip_warning_notFound')
        } else {
          updatedPreviewIntegrity.petition = I18n.t('smartchat_tooltip_warning_notFound')
        }
      }

      // Update local data
      setValue(updatedValue)

      // // Error reports
      if (renderType === 'action') {
        if (Object.keys(error.COMMAND).length) dataWay?.type === 'alternatives'
          ? dispatch(setAlternativesActionsErrors({ alternativesId: dataWay.alternativesId, actionsErrors: error }))
          : dispatch(updateActionsErrors(error))
      } else {
        if (Object.keys(updatedPreviewIntegrity).length) setPreviewIntegrity(updatedPreviewIntegrity)
      }
    }

    return () => isSubscribed = false
  }, [currentValue])

  const onChangeInner = ({ fieldType, fieldData }) => {
    const updatedValue = { ...value }
    const updatedDataToExport = { ...dataToExport }

    // Data to export
    if (fieldType === 'message') {
      if (fieldData) {
        updatedValue.message = fieldData
        updatedDataToExport.intentId = fieldData.value
      }
      // Clear later fields and data
      if (updatedValue.petition) {
        updatedValue.petition = null
        updatedDataToExport.repetitionNumber = null
      }
    }
    if (fieldType === 'petition') {
      if (fieldData) {
        updatedValue.petition = fieldData
        updatedDataToExport.repetitionNumber = fieldData.value
      }
    }

    // Update local data
    setValue(updatedValue)
    setDataToExport(updatedDataToExport)

    // Export the data
    onChange(updatedDataToExport)
  }

  return (
    <CourtesyMessagesViewUI
      renderType={renderType}
      label={label}
      placeholder={placeholder}
      courtesyMessagesOptions={courtesyMessagesOptions}
      helloPetitionsOptions={helloPetitionsOptions}
      byePetitionsOptions={byePetitionsOptions}
      thanksPetitionsOptions={thanksPetitionsOptions}
      value={value}
      onChangeInner={onChangeInner}
      error={error}
      previewIntegrity={previewIntegrity}
    />
  )
}

export default CourtesyMessagesView
